/**
 * Router Routes
 */

// Views
import Login from '@/views/Login'
// import Main from '@/views/Main'

const Main = r => require.ensure([], () => r(require('@/views/Main')), 'MAIN_GROUP')
const MainLeft = r => require.ensure([], () => r(require('@/views/partials/MainLeft')), 'MAIN_GROUP')
const MainRight = r => require.ensure([], () => r(require('@/views/partials/MainRight')), 'MAIN_RIGHT')

// Partials
import Home from '@/views/partials/Home'
import Dashboard from '@/views/partials/Dashboard'
// import Content from '@/views/partials/Content'
// import Model from '@/views/partials/Model'

// Components
const Content = r => require.ensure([], () => r(require('@/views/partials/Content')), 'CONTENT_GROUP')
const ContentNav = r => require.ensure([], () => r(require('@/components/ContentNav')), 'CONTENT_GROUP')
const ContentList = r => require.ensure([], () => r(require('@/components/ContentList')), 'CONTENT_GROUP')
const ContentForm = r => require.ensure([], () => r(require('@/components/ContentForm')), 'CONTENT_GROUP')
const Contents = r => require.ensure([], () => r(require('@/views/partials/Contents')), 'CONTENT_GROUP')
const ContentModal = r => require.ensure([], () => r(require('@/views/partials/ContentModal')), 'CONTENT_GROUP')
const ImportForm = r => require.ensure([], () => r(require('@/components/ImportForm')), 'IMPORT_GROUP')

const Model = r => require.ensure([], () => r(require('@/views/partials/Model')), 'MODEL_GROUP')
const ModelNav = r => require.ensure([], () => r(require('@/components/ModelNav')), 'MODEL_GROUP')
const ModelForm = r => require.ensure([], () => r(require('@/components/ModelForm')), 'MODEL_GROUP')
const PropertyForm = r => require.ensure([], () => r(require('@/components/PropertyForm')), 'MODEL_GROUP')
const PropertyModal = r => require.ensure([], () => r(require('@/views/partials/PropertyModal')), 'MODEL_GROUP')

const Profile = r => require.ensure([], () => r(require('@/views/partials/Profile')), 'PROFILE_GROUP')

const HomeLeft = r => require.ensure([], () => r(require('@/views/partials/HomeLeft')), 'HOME_GROUP')

const SiteHeader = r => require.ensure([], () => r(require('@/components/SiteHeader')), 'HOME_GROUP')
const SiteFooter = r => require.ensure([], () => r(require('@/components/SiteFooter')), 'HOME_GROUP')

const ProfileForm = r => require.ensure([], () => r(require('@/components/ProfileForm')), 'PROFILE_GROUP')

const leftComponents = {
	leftContent: ContentNav,
	leftHeader: SiteHeader,
	leftFooter: SiteFooter,
}

const ContentLeft = {
	leftContent: ContentNav,
	leftHeader: SiteHeader,
	leftFooter: SiteFooter,
}

const ModelLeft = {
	leftContent: ModelNav,
	leftHeader: SiteHeader,
	leftFooter: SiteFooter,
}

const ProfileLeft = {
	// leftContent: ModelNav,
	leftHeader: SiteHeader,
	leftFooter: SiteFooter,
}

const MainLeftComponents = {
	leftHeader: SiteHeader,
	leftFooter: SiteFooter,
}

const MainComponents = {
	left: MainLeft,
	right: MainRight,
}

// Export
const routes = [
	{
		path: '/',
		component: Main,
		meta: {
			requiresAuth: true,
		},
		children: [
			{
				path: '',
				components: Object.assign({}, MainComponents, {
					content: Home,
				}),
				children: [
					{
						path: '',
						components: Object.assign({}, MainLeftComponents, {
							leftContent: ContentNav,
						}),
					},
				],
			},
			{
				path: 'content',
				components: Object.assign({}, MainComponents, {
					content: Home,
				}),
				children: [
					{
						name: 'content',
						path: '',
						components: Object.assign({}, MainLeftComponents, {
							leftContent: ContentNav,
						}),
					},
				],
			},
			{
				path: 'content/:key/:pg(\\d+)?',
				components: Object.assign({}, MainComponents, {
					content: Contents,
				}),
				children: [
					{
						name: 'contentModel',
						path: '',
						components: Object.assign({}, MainLeftComponents, {
							leftContent: ContentNav,
						}),
					},
				],
			},
			{
				path: 'content/:key/:uid',
				components: Object.assign({}, MainComponents, {
					content: Content,
				}),
				children: [
					{
						name: 'item',
						path: '',
						components: Object.assign({}, MainLeftComponents, {
							leftContent: ContentNav,
						}),
					},
				],
			},
			{
				path: 'content/:key/:uid/:newKey/:newUid',
				components: Object.assign({}, MainComponents, {
					content: Content,
					modal: ContentModal,
				}),
				meta: {
					showModal: true,
					title: 'Edit Content',
				},
				children: [
					{
						name: 'contentModal',
						path: '',
						components: Object.assign({}, MainLeftComponents, {
							leftContent: ContentNav,
						}),
					},
				],
			},
			{
				path: 'model',
				components: Object.assign({}, MainComponents, {
					content: Model,
				}),
				children: [
					{
						name: 'model',
						path: '',
						components: Object.assign({}, MainLeftComponents, {
							leftContent: ModelNav,
						}),
					},
				],
			},
			{
				path: 'model/:key',
				components: Object.assign({}, MainComponents, {
					content: Model,
				}),
				children: [
					{
						name: 'editModel',
						path: '',
						components: Object.assign({}, MainLeftComponents, {
							leftContent: ModelNav,
						}),
					},
				],
			},
			{
				path: 'model/:key/property',
				components: Object.assign({}, MainComponents, {
					content: Model,
					modal: PropertyModal,
				}),
				children: [
					{
						name: 'addProperty',
						path: '',
						components: Object.assign({}, MainLeftComponents, {
							leftContent: ModelNav,
						}),
						meta: {
							showModal: true,
							title: 'Add Property',
						},
					},
				],
			},
			{
				path: 'model/:key/property/:prop',
				components: Object.assign({}, MainComponents, {
					content: Model,
					modal: PropertyModal,
				}),
				children: [
					{
						name: 'editProperty',
						path: '',
						components: Object.assign({}, MainLeftComponents, {
							leftContent: ModelNav,
						}),
						meta: {
							showModal: true,
							title: 'Edit Property',
						},
					},
				],
			},
			{
				path: 'profile',
				components: Object.assign({}, MainComponents, {
					content: Profile,
				}),
				children: [
					{
						name: 'profile',
						path: '',
						components: Object.assign({}, MainLeftComponents, {
							leftContent: ContentNav,
						}),
					},
				],
			},
		],
	},
	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			title: 'Login',
			requiresAuth: false,
		},
	},

]

export default routes



// WEBPACK FOOTER //
// ./src/lib/router/routes.js